export var ReferralType = /*#__PURE__*/function (ReferralType) {
  ReferralType["None"] = "None";
  ReferralType["PBS"] = "PBS";
  ReferralType["ECREF"] = "ECREF";
  return ReferralType;
}({});